import {GET, POST, PUT, DELETE, reUrl} from '../../axiosconfig/axiosconfig'

export default {
    // 获取用户列表
    listUsers: function (params) {
        return GET(reUrl + '/user/role_list/', params)
    },

    // 获取用户信息
    getUserInfo: function (params) {
        return GET(reUrl + '/user/info/', params)
    },

    // 更新用户角色
    updateRoleUsers: function (params) {
        return POST(reUrl + '/user/update_role_users/', params)
    },

    // 创建用户
    createRoleUser: function (params) {
        return POST(reUrl + '/user/create_role_user/', params)
    },

    // 编辑用户
    updateRoleUser: function (params) {
        return POST(reUrl + '/user/update_role_user/', params)
    },

    // 获取Subsonic密码
    getSubsonicPassword: function (params) {
        return GET(reUrl + '/user/subsonic_password/', params)
    },

    // 更新Subsonic密码
    updateSubsonicPassword: function (params) {
        return POST(reUrl + '/user/update_subsonic_password/', params)
    },

    // 获取Last.fm配置
    getLastfmProfile: function (params) {
        return GET(reUrl + '/user/lastfm_profile/', params)
    },

    // 更新Last.fm配置
    updateLastfmProfile: function (params) {
        return POST(reUrl + '/user/update_lastfm_profile/', params)
    }
}
